/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_P1Inputs */

const tr_onbilgi_s11_p1 = /** @type {(inputs: Onbilgi_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-j uyarınca Platform'a erişim için gerekli asgari donanım ve yazılım gereklilikleri:`)
};

const en_onbilgi_s11_p1 = /** @type {(inputs: Onbilgi_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum hardware and software requirements for access to the Platform pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-j:`)
};

const de_onbilgi_s11_p1 = /** @type {(inputs: Onbilgi_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestanforderungen an Hardware und Software für den Zugang zur Plattform nach Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-j:`)
};

const ru_onbilgi_s11_p1 = /** @type {(inputs: Onbilgi_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальные требования к оборудованию и программному обеспечению для доступа к Платформе согласно Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-j:`)
};

/**
* | output |
* | --- |
* | "Minimum hardware and software requirements for access to the Platform pursuant to Mesafeli Sözleşmeler Yönetmeliği Madde 5/1-j:" |
*
* @param {Onbilgi_S11_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_p1 = /** @type {((inputs?: Onbilgi_S11_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_p1(inputs)
	if (locale === "de") return de_onbilgi_s11_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s11_p1(inputs)
	return tr_onbilgi_s11_p1(inputs)
});